<!-- filepath: frontend/src/views/SuccessPage.vue -->
<template>
    <div class="success-page">
      <h1>Success!</h1>
      <p>Your listing has been submitted successfully.</p>
      <v-btn @click="$router.push('/ats/jobs-dashboard')">Go to Jobs Dashboard</v-btn>
    </div>
  </template>
  
  <script>
  export default {
    name: "SuccessPageForJob",
  };
  </script>
  
  <style scoped>
  .success-page {
    text-align: center;
    margin-top: 50px;
  }
  </style>